module.exports = {"name":"Hack Club Ship","title":"Share Your Latest Project with the Community","description":"Share your latest project with other hackers in the community.","url":"https://ship.hackclub.com"}


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 754
// module chunks = 114276838955818